"use strict";

require("core-js/modules/es6.array.filter.js");

var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

require("core-js/modules/es6.function.bind.js");

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TagSale = _interopRequireDefault(require("@ucloud/ucloud-icons/dist/uc-tag/svgr/TagSale"));

var _style = require("./style");

var _excluded = ["size", "style"];

var _this = void 0;

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * ChargeInfo.SaleTag
 * @description 计费UI组件-促销标签
 */
var SaleTag = function SaleTag(_ref) {
  (0, _newArrowCheck2["default"])(this, _this);
  var size = _ref.size,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      others = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var sizeMap = {
    md: "18px",
    sm: "14px"
  };
  return /*#__PURE__*/_react["default"].createElement(_style.StyledSaleTag, (0, _extends2["default"])({
    size: size,
    style: _objectSpread({
      lineHeight: sizeMap[size]
    }, style)
  }, others), /*#__PURE__*/_react["default"].createElement(_TagSale["default"], null));
}.bind(void 0);

SaleTag.propTypes = {
  /** 促销标签的尺寸 */
  size: _propTypes["default"].oneOf(["sm", "md"]),

  /** @ignore **/
  style: _propTypes["default"].object
};
SaleTag.defaultProps = {
  size: "md"
};
var _default = SaleTag;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/ChargeInfo/SaleTag.js
// module id = 2087
// module chunks = 6 7 17 18